import AllRoutes from "./routes";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
const App = () => {
  return (
    <>
      <AllRoutes />
      <ToastContainer />
    </>
  );
}

export default App;
